import business from './business/routes';
import consumer from './consumer/routes';
import notfound from './notfound/routes';
import perfectbeauty from './perfectbeauty/routes';
import specialRedirects from './redirects/routes';
import _flattenDeep from 'lodash/flattenDeep';

export default lang => {
  const en = _flattenDeep([business, consumer, perfectbeauty]).map(route => ({
    ...route,
    props: {
      ...route.props,
      path: route.props.path,
    },
  }));

  const all = _flattenDeep([business, consumer, perfectbeauty]).map(route => ({
    ...route,
    props: {
      ...route.props,
      path:
        route.props.path &&
        `/:lang(ja|zh-tw|zh-cn|fr|de|es|ko|pt|it|tr|id|ru|th|gn|he|ar|pl|tl|ro|af|uk|el|sv|hu|bg|da|hr|vi|nl)${route.props.path}`,
      from:
        route.props.from &&
        `/:lang(ja|zh-tw|zh-cn|fr|de|es|ko|pt|it|tr|id|ru|th|gn|he|ar|pl|tl|ro|af|uk|el|sv|hu|bg|da|hr|vi|nl)${route.props.from}`,
      to:
        route.props.to &&
        `/:lang(ja|zh-tw|zh-cn|fr|de|es|ko|pt|it|tr|id|ru|th|gn|he|ar|pl|tl|ro|af|uk|el|sv|hu|bg|da|hr|vi|nl)${route.props.to}`,
    },
  }));

  const n = _flattenDeep([notfound]).map(route => ({
    ...route,
    props: {
      ...route.props,
    },
  }));

  const special = _flattenDeep([specialRedirects]).map(route => ({
    ...route,
    props: {
      ...route.props,
    },
  }));

  return [special, en, all, n];
};
